import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { faEye, faPencil, faTrashAlt, faImage } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index';
import { useNavigate } from "react-router-dom";
import SideBar from './NHBSideBar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


function NHBDetails() {
    const navigate = useNavigate();
    const [details, setDetails] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Inspection/CDPDetails/getCDPDetailsList`, { "createdBy" : sessionStorage.getItem("userCode")}
      );
      setDetails(result.data.dataContent);
      console.log("result", result);
    
    };
    fetchData();
  }, []);

  function formatDate(originalRow) {
    
    let valuess = (originalRow.createdOn).split("T")
    var format = valuess[0].split("-")
    var formatTime = valuess[1].split(":")
    return format[2] + "-" + format[1] + "-" + format[0] + " "+ formatTime[0] + ":" + formatTime[1]
    
}



function removed() {
    var mpopup = document.getElementById('mpopupBox');
    mpopup.style.display = "none";

}

  const columns = useMemo(
    () => [
        {
            header: 'S.No',
            Cell: cell => Number(cell.row.id) + 1
        },
        {
            accessorKey: 'schemeName',
            header: 'Scheme Name',  
        },
        {
            accessorKey: 'observations',
            header: 'Observations',
        },
        {
            accessorKey: 'stateName',
            header: 'State ',
        },
        {
            accessorKey: 'districtName',
            header: 'District ',
        },
        {
            accessorKey: 'subDistrictName',
            header: 'SubDistrict',
        },
        {
            accessorKey: 'villageName',
            header: 'Village',
        },
        {
            header: 'Inspection Date',
            accessorFn: (originalRow) => formatDate(originalRow), //alternative to accessorKey, using accessorFn
            id: 'createdOn',
        },
        {
            accessor: '',
            header: 'View Image',
            Cell: cell => <div data-bs-toggle="modal" data-bs-target="#staticBackdrop"> <i><FontAwesomeIcon className="hover" icon={faImage} onClick={() => navigate("/inspection/singleinspectionview", { state: { inspectionCode : cell.row.original } })}/></i></div>
        },

      
        // {
        //     accessor: '',
        //     header: 'Actions',
        //     Cell: cell => <><i className="btn text-success" type="button" onClick={(e) => viewData(cell.row.original)}> <FontAwesomeIcon icon={faEye} /></i>
        //         <i className="btn text-primary" type="button" onClick={() => navigate("/usermanagement/users/addnewuser", { state: { cropSurveyCode: cell.row.original } })}><FontAwesomeIcon icon={faPencil} /></i>
        //         <i className="btn text-danger" type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop_user" onClick={() => setDeleteCode({ "UserCode": cell.row.original.userCode, "ModifiedByUC": cell.row.original.modifiedByUC })}> <FontAwesomeIcon icon={faTrashAlt} /></i></>
        // },
    ]
   
);

  return (
    <>
      <SideBar />
      <main id="main" className="main">
      <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
                   <nav>
                        <h1>Inspection Details</h1>
                        <ol></ol>
                       
                        {/* <ol className="breadcrumb">
                            <li className="breadcrumb-item"></li>
                            <li className="breadcrumb-item active"></li>
                        </ol> */}
                    </nav>
                   {/* <button type="button" className="btn btn-success" onClick={() => navigate("/usermanagement/users/addnewuser")}>Add New</button> */}
                </div>
      <section className="section">
                 
                 <div className="row justify-content-lg-center">
                     <div className="col-lg-12 ">

                         <div className="card">
                           
                             <MaterialReactTable
                                 columns={columns}
                                 data={details}
                                 enableColumnOrdering
                                 enablePagination={true}
                             />
                         </div>

                     </div>

                    
                 </div>
             </section>
             </main>
          
    </>
  );
}

export default NHBDetails;
